import React from 'react';
import Login from '../components/Login';

const ClientLogin: React.FC = () => {
  return <Login userRole="client" />;
};

export default ClientLogin;

